/* Vibee popup gate — scratch popup ne zaman açılır, tek yetkili burası.
 *
 * Sözleşme (Ağu 2026 UX kalibrasyonu):
 *   · İlk page view'da AÇILMAZ.
 *   · Tetikleyiciler (hangisi önce gelirse): 20 sn VEYA %50 scroll derinliği
 *     VEYA exit-intent (yalnız desktop, mouseout clientY<=0).
 *   · Oturum başına en fazla 1 gösterim  → sessionStorage vb_scratch_shown
 *     (anahtarı popup açıldığı anda scratch-popup section'ı yazar; gate
 *     boşa ateşlerse — popup o sayfada kapalıysa — oturum hakkı yanmaz).
 *   · Formu dolduran kalıcı olarak görmez → localStorage vb_scratch_signed
 *     (submit success handler'ında set edilir; vbsc_done eski anahtarı da
 *     geriye uyum için sayılır).
 *
 * Gate karar verir, popup'ı sections/scratch-popup.liquid çizer: burada
 * `vibee:scratch:open` event'i yayınlanır + window.__vibeeScratchGateFired
 * bayrağı kalkar; section hangisini önce görürse onunla açılır.
 */
(function () {
  'use strict';

  if (/(?:^|\/)products\//.test(window.location.pathname) || /(?:^|\/)cart(?:\/|$)/.test(window.location.pathname)) return;

  var KEY_SESSION = 'vb_scratch_shown';
  var KEY_DONE = 'vb_scratch_signed';
  var DELAY_MS = 20000;
  var SCROLL_PCT = 50;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }

  if (lsGet(KEY_DONE) || lsGet('vbsc_done')) return;
  if (ssGet(KEY_SESSION)) return;

  var fired = false;
  var timerId = null;
  var pollId = null;

  function scrollPct() {
    var st = window.pageYOffset || document.documentElement.scrollTop || 0;
    var dh = document.documentElement.scrollHeight - window.innerHeight;
    return dh > 0 ? (st / dh) * 100 : 0;
  }

  function onScroll() {
    if (scrollPct() >= SCROLL_PCT) trigger();
  }

  function onMouseOut(e) {
    if (!e.relatedTarget && e.clientY <= 0) trigger();
  }

  function trigger() {
    if (fired) return;
    fired = true;
    if (timerId) clearTimeout(timerId);
    if (pollId) clearInterval(pollId);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('scroll', onScroll, true);
    document.removeEventListener('mouseout', onMouseOut);
    window.__vibeeScratchGateFired = true;
    try { window.dispatchEvent(new CustomEvent('vibee:scratch:open')); } catch (e) { /* eski tarayıcı: bayrak yeter */ }
  }

  timerId = setTimeout(trigger, DELAY_MS);

  // Scroll: üç katman — vibee-header.js ile aynı gerekçe; bu temada scroll
  // event'i her zaman window'a düşmüyor (bkz. theme.liquid "triple-layer scroll").
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  pollId = setInterval(onScroll, 500);

  if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
    document.addEventListener('mouseout', onMouseOut);
  }
})();

